<template>
  <div
    @click="$store.commit('modals/OPEN_ADD_PRODUCT_TYPE_POPUP', false)"
    class="py-3 md-pd flex items-center w-full h-full justify-center add-product__modal__container"
  >
    <section
      @click.stop
      class="w-full md:w-1/2 lg:w-1/3 p-4 add-product__modal__container__chat relative"
    >
      <div
        @click="$store.commit('modals/OPEN_ADD_PRODUCT_TYPE_POPUP', false)"
        class="flex absolute items-center justify-center cross-icon cursor-pointer z-20"
      >
        X
      </div>

      <div class="w-full flex flex-col gap-y-4">
        <h4 class="text-2xl font-extrabold text-center">
          <!-- {{ product.product_name }} -->
        </h4>

        <vs-input
          v-model="productType"
          placeholder="Product Type"
          class="w-full"
        />
        <!-- <vs-input
          v-model="productTypeBrief"
          placeholder="What is this product type?"
          class="w-full"
        /> -->
        <!-- <div class="flex gap-x-4">
          <vs-input
            v-model="productInStock"
            placeholder="Inventory Count"
            class="w-full"
          />
          <vs-input
            v-model="productPrice"
            placeholder="Product Price"
            class="w-full"
          />
        </div> -->
        <!-- <div class="flex gap-x-2"> -->
        <vs-button @click="addProductType()"> Add Product Type </vs-button>
        <!-- <button @click="deleteProduct()" class="w-1/2">Delete</button> -->
        <!-- </div> -->
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "AddProductTypeModal",
  data() {
    return {
      productType: "",
    };
  },
  props: {
    addProductTypeActive: Boolean,
    orgId: {
      required: true,
      type: String,
    },
  },
  computed: {
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
    userData() {
      return this.$store.state.users.data;
    },
  },
  methods: {
    addProductType() {
      const payload = {
        userId: this.userData._id,
        orgId: this.orgId,
        productType: this.productType,
      };
      console.log(this.productType, this.orgId);
      this.$store
        .dispatch("organization/addProductType", payload)
        .then((response) => {
          this.$parent.fetchProductTypes();
          this.$store.commit("modals/OPEN_ADD_PRODUCT_TYPE_POPUP", false);
        })
        .catch((error) => {
          // console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.cross-icon {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  top: 0;
  font-size: 1.5em;
  padding: 0.5em;
  border-radius: 50%;
  height: 2em;
  width: 2em;
  top: -0.5em;
  right: -0.5em;
  transition: all 0.23s ease 0.1s;
  transform: translate(8px, -2px);
  font-family: "Montserrat", Helvetica, Arial, serif;
  background: #fffffffa;
  // For hover effect of close btn
  &:hover,
  &:focus,
  &:active {
    opacity: 1;
    outline: none;
    transform: translate(5px, 3px);
    box-shadow: none;
  }
}
.skeleton {
  position: relative;
  margin: 2em 0;
  padding: 10em 0;
  border-radius: 10px;
  background: rgb(128, 128, 128);
  animation: flicker-light 1s infinite alternate;
}
@keyframes flicker-light {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.2;
  }
}
.b-dropdown ::v-deep .dropdown-toggle {
  white-space: normal;
}

.add-product__modal {
  &__container {
    background: #0000006a;
    backdrop-filter: blur(5px);
    position: fixed !important;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 100000;
    &__chat {
      width: 35%;
      border-radius: 10px;
      background: #fff;
      .text {
        color: #1c1c1e;
      }
    }

    .vs-tooltip {
      z-index: 5200000;
    }
    .card {
      background: #ffffff;
      box-shadow: 6px 6px 29px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
    }
    .validate-btn {
      font-size: 1.2em;
      background: grey;
      color: #fff;
      border-radius: 10px;
    }
    .validate-icon {
      filter: invert(91%) sepia(34%) saturate(1988%) hue-rotate(321deg)
        brightness(99%) contrast(92%);
    }
    .choose-skill__chat {
      width: 25%;
      max-height: 27.5em;
      height: auto;
      // top: 17.5%;
    }

    .choose-skill {
      &__avatar {
        // width: 100%;
      }
      &__btns {
        .btn {
          padding: 1em;
          background-color: #82868b;
          color: #ffffff;
          width: 55%;
        }
      }
    }

    .overflow-container {
      max-height: 25em;
      overflow-y: scroll;
    }
  }
}

@media only screen and (max-width: 1400px) {
  .add-product__modal {
    &__container {
      .choose-skill {
        &__btns {
          .btn {
            width: 70%;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .add-product__modal {
    &__container {
      .choose-skill {
        &__chat {
          right: 2.75em;
          width: 32%;
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .md-pd {
    padding: 1.5em !important;
  }
  .add-product__modal {
    &__container {
      &__chat {
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .md-pd {
    padding: 1.5em !important;
  }
  .add-product__modal {
    &__container {
      .choose-skill {
        &__chat {
          width: 50%;
          max-height: 75%;
          height: auto;
        }
      }
    }
  }
}

@media only screen and (max-width: 660px) {
  .add-product__modal {
    &__container {
      // &__chat {
      //   width: 95%;
      //   height: 75%;
      //   top: 3.5em;
      // }

      .choose-skill__chat {
        width: 95%;
      }
      .choose-skill {
        &__avatar {
          img {
            width: 25%;
          }
        }
      }
    }
  }
}
</style>
